import script from "./UserReferralWorkflowModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserReferralWorkflowModal.vue?vue&type=script&setup=true&lang=ts"

import "./UserReferralWorkflowModal.vue?vue&type=style&index=0&id=193a56e6&lang=scss"

const __exports__ = script;

export default __exports__